// Generated by `bazel run i18n`. Do not edit by hand.
import part0 from "./en/src--flows--chat-flow.json";
import part1 from "./en/src--flows--return-flow--condition-types.json";
import part2 from "./en/src--flows--return-flow.json";
import part3 from "./en/src--flows--rules--conditions.json";
import part4 from "./en/src--flows--rules.json";
import part5 from "./en/src--flows.json";

export default Object.assign(
  {},
  part0,
  part1,
  part2,
  part3,
  part4,
  part5,
);
